export const DEMAND_GENERATE_CREATE_REQUEST = 'DEMAND_GENERATE_CREATE_REQUEST';
export const DEMAND_GENERATE_CREATE_SUCCESS = 'DEMAND_GENERATE_CREATE_SUCCESS';
export const DEMAND_GENERATE_CREATE_FAIL = 'DEMAND_GENERATE_CREATE_FAIL';
export const DEMAND_GENERATE_CREATE_RESET = 'DEMAND_GENERATE_CREATE_RESET';

export const DEMAND_GENERATE_DOWNLOAD_REQUEST = 'DEMAND_GENERATE_DOWNLOAD_REQUEST';
export const DEMAND_GENERATE_DOWNLOAD_SUCCESS = 'DEMAND_GENERATE_DOWNLOAD_SUCCESS';
export const DEMAND_GENERATE_DOWNLOAD_FAIL = 'DEMAND_GENERATE_DOWNLOAD_FAIL';
export const DEMAND_GENERATE_DOWNLOAD_RESET = 'DEMAND_GENERATE_DOWNLOAD_RESET';


export const DEMAND_GENERATE_BATCH_REQUEST = 'DEMAND_GENERATE_BATCH_REQUEST';
export const DEMAND_GENERATE_BATCH_SUCCESS = 'DEMAND_GENERATE_BATCH_SUCCESS';
export const DEMAND_GENERATE_BATCH_FAIL = 'DEMAND_GENERATE_BATCH_FAIL';
export const DEMAND_GENERATE_BATCH_RESET = 'DEMAND_GENERATE_BATCH_RESET';

export const DEMAND_GENERATE_BATCH_NOTICES_REQUEST = 'DEMAND_GENERATE_BATCH_NOTICES_REQUEST';
export const DEMAND_GENERATE_BATCH_NOTICES_SUCCESS = 'DEMAND_GENERATE_BATCH_NOTICES_SUCCESS';
export const DEMAND_GENERATE_BATCH_NOTICES_FAIL = 'DEMAND_GENERATE_BATCH_NOTICES_FAIL';
export const DEMAND_GENERATE_BATCH_NOTICES_RESET = 'DEMAND_GENERATE_BATCH_NOTICES_RESET';

export const DEMAND_GENERATE_LIST_REQUEST = 'DEMAND_GENERATE_LIST_REQUEST';
export const DEMAND_GENERATE_LIST_SUCCESS = 'DEMAND_GENERATE_LIST_SUCCESS';
export const DEMAND_GENERATE_LIST_FAIL = 'DEMAND_GENERATE_LIST_FAIL';
export const DEMAND_GENERATE_LIST_RESET = 'DEMAND_GENERATE_LIST_RESET';
